import type { TaskDefinition } from "@gearbox-protocol/deploy-tools-shared";
import clsx from "clsx";
import type { FC } from "react";
import { Link } from "react-router-dom";

import TaskDefinitionDropdownMenu from "./dropdown";

interface TaskDefinitionsListProps {
  tasks: TaskDefinition[];
  className?: string;
}

const TaskDefinitionsList: FC<TaskDefinitionsListProps> = ({
  tasks,
  className,
}) => {
  return (
    <ul className={clsx("list-disc pl-4", className)}>
      {tasks.map(f => (
        <TaskDefinitionsListItem key={f.id} {...f} />
      ))}
    </ul>
  );
};

const TaskDefinitionsListItem: FC<TaskDefinition> = props => {
  const { id, description } = props;

  return (
    <li className="hover:bg-muted flex flex-row items-center">
      <div className="flex flex-col p-1">
        <div className="flex flex-row items-center">
          <Link to={id ?? ""}>{id}</Link>
        </div>
        {!!description && (
          <p className="text-muted-foreground text-sm">{description}</p>
        )}
      </div>
      <TaskDefinitionDropdownMenu
        definitionId={id ?? ""}
        variant="link"
        className="ml-2 hover:bg-slate-600"
      />
    </li>
  );
};

export default TaskDefinitionsList;
